import {
  FETCH_USER_INFO,
  FETCH_USER_FAVOUR,
  REGISTER_USER,
  UPDATE_USER,
} from '../mutation-types'

const initialState = {
  favour: [],
  currentUser: {},
}

const mutations = {
  [FETCH_USER_INFO](state, user) {
    state.currentUser = user
  },

  [FETCH_USER_FAVOUR](state, data) {
    state.favour = data.favours
  },

  [REGISTER_USER](state, user) {
    state.currentUser = user
  },

  [UPDATE_USER](state, mobile) {
    state.currentUser.mobile = mobile
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/user.js